import styled from 'styled-components'

export const DetailWrapper = styled.div`
  margin-top: 24px;
`

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  &:hover {
    color: #333;
  }
`

export const StatusBadge = styled.div<{ color: string }>`
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
`

export const MetadataSection = styled.div`
  margin-bottom: 32px;

  h3 {
    margin-bottom: 20px;
    font-size: 20px;
  }

  .metadata-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
`

export const MetadataItem = styled.div`
  display: flex;
  flex-direction: column;

  .label {
    font-size: 12px;
    color: #888;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .value {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
`

export const PhasesSection = styled.div`
  h2 {
    font-size: 24px;
    margin-bottom: 24px;
  }
`

export const PhaseCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`

export const PhaseHeader = styled.div`
  padding: 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  &.expanded {
    border-bottom: 1px solid #e0e0e0;
  }

  .phase-title {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;

    .phase-number {
      font-size: 12px;
      color: #888;
      text-transform: uppercase;
    }

    h3 {
      margin: 0;
      font-size: 18px;
      flex: 1;
    }
  }

  .expand-icon {
    font-size: 24px;
    color: #666;
    font-weight: 300;
  }
`

export const PhaseContent = styled.div`
  padding: 20px;

  .phase-goal {
    background: #f5f5f5;
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .reasoning-steps {
    margin-bottom: 24px;

    h4 {
      font-size: 16px;
      margin-bottom: 12px;
    }
  }

  .phase-outputs {
    margin-bottom: 24px;

    h4 {
      font-size: 16px;
      margin-bottom: 12px;
    }
  }

  .phase-conclusion {
    background: #e8f5e9;
    padding: 12px 16px;
    border-radius: 6px;
    margin-top: 20px;
    font-size: 14px;
    border-left: 4px solid #4ba765;
  }
`

export const ReasoningStep = styled.div`
  padding: 8px 12px;
  margin: 4px 0;
  font-size: 14px;
  color: #555;
  background: #fafafa;
  border-radius: 4px;
`

export const OutputCard = styled.div`
  background: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;

  h4 {
    font-size: 14px;
    margin-bottom: 8px;
    color: #333;
  }

  p {
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  &.error {
    background: #ffebee;
    border-color: #ffcdd2;

    h4 {
      color: #c62828;
    }
  }

  .markdown-content {
    font-size: 14px;
    line-height: 1.6;

    h2 {
      font-size: 18px;
      margin-top: 16px;
      margin-bottom: 8px;
    }

    h3 {
      font-size: 16px;
      margin-top: 12px;
      margin-bottom: 6px;
    }

    ul,
    ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
    }

    strong {
      font-weight: 600;
    }
  }
`

export const CodeBlock = styled.div`
  background: #2d2d2d;
  border-radius: 6px;
  padding: 16px;
  margin-top: 8px;
  overflow-x: auto;

  pre {
    margin: 0;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.5;
    color: #f8f8f2;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  code {
    font-family: inherit;
  }
`

export const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 16px;

  .file-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 16px;

    .file-name {
      font-weight: 500;
      color: #333;
      margin-bottom: 4px;
    }

    .file-size {
      font-size: 12px;
      color: #888;
    }

    .file-description {
      font-size: 12px;
      color: #666;
      margin-top: 4px;
    }
  }

  .file-type {
    background: #e0e0e0;
    color: #666;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    margin-right: 12px;
  }

  .file-path {
    font-family: monospace;
    font-size: 12px;
    color: #666;
    margin-left: 8px;
  }
`

export const FileGrid = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 16px;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;

  p {
    font-size: 16px;
    color: #666;
  }
`

export const ErrorState = styled.div`
  text-align: center;
  padding: 80px 20px;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    color: #ff4444;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 24px;
  }
`

export const SimpleCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;

  h3 {
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: 600;
  }

  h4 {
    font-size: 16px;
    margin-bottom: 12px;
    font-weight: 600;
  }
`

// Reports Section Styled Components
export const ReportsSection = styled.div`
  margin-top: 32px;
`

export const ReportsGrid = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 16px;
`

export const ReportFolder = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;

  .folder-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;

    h4 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #212529;
    }

    .folder-icon {
      font-size: 18px;
    }

    .item-count {
      font-size: 14px;
      color: #6c757d;
      font-weight: normal;
    }

    .expand-icon {
      font-size: 18px;
      color: #6c757d;
    }
  }

  &.expanded .expand-icon {
    transform: rotate(90deg);
  }
`

export const ReportFilesList = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 12px;
  padding-left: 24px;
`

export const ReportFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    border-color: #007bff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
  }

  .file-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;

    .file-icon {
      font-size: 20px;
      flex-shrink: 0;
    }

    .file-details {
      flex: 1;

      .file-name {
        font-size: 14px;
        font-weight: 500;
        color: #212529;
        display: block;
        margin-bottom: 2px;
      }

      .file-meta {
        font-size: 12px;
        color: #6c757d;
        display: flex;
        gap: 12px;
      }
    }
  }

  .file-actions {
    display: flex;
    gap: 8px;
  }
`

export const ReportActionButton = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  background: #fff;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
  }

  &.primary {
    background: #007bff;
    color: #fff;
    border-color: #007bff;

    &:hover {
      background: #0056b3;
      border-color: #0056b3;
    }
  }
`

export const ReportViewer = styled.div`
  margin-top: 24px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;

  .viewer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;

    h4 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }

    .viewer-actions {
      display: flex;
      gap: 8px;
    }
  }

  .viewer-content {
    position: relative;
    width: 100%;
    height: 600px;

    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }

    .viewer-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #6c757d;
    }
  }
`
